import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Tag = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path
        d="M12.53 3.528A1.8 1.8 0 0 0 11.257 3H4.8A1.8 1.8 0 0 0 3 4.8v6.457c0 .477.19.935.528 1.273l7.835 7.835a2.184 2.184 0 0 0 3.079 0l5.923-5.923a2.184 2.184 0 0 0 0-3.079z"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M7.875 9a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(Tag) as SvgIcon;
export { ForwardRef as ReactComponent };
